/**
 * API wrapper for programmes catalog management
 */

import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/admin/programmes');
const LIST_API_BASE = apiUrl('/api/plans/programmes');

export async function getProgrammes(onlyActive = false) {
  const url = onlyActive ? `${LIST_API_BASE}?only_active=true` : LIST_API_BASE;
  const response = await apiFetch(url, { auth: true });

  if (!response.ok) {
    throw new Error('Erreur lors du chargement des programmes');
  }

  const data = await response.json();
  return data.programmes || [];
}

export async function getProgrammeById(programmeId) {
  const response = await apiFetch(`${API_BASE}/${programmeId}`, { auth: true });

  if (!response.ok) {
    throw new Error('Erreur lors du chargement du programme');
  }

  return response.json();
}

export async function createProgramme(programme) {
  const response = await apiFetch(API_BASE, {
    method: 'POST',
    auth: true,
    json: true,
    body: JSON.stringify(programme)
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erreur lors de la création du programme');
  }

  return response.json();
}

export async function updateProgramme(programmeId, updates) {
  const response = await apiFetch(`${API_BASE}/${programmeId}`, {
    method: 'PUT',
    auth: true,
    json: true,
    body: JSON.stringify(updates)
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erreur lors de la mise à jour du programme');
  }

  return response.json();
}

export async function deleteProgramme(programmeId) {
  const response = await apiFetch(`${API_BASE}/${programmeId}`, {
    method: 'DELETE',
    auth: true,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erreur lors de la suppression du programme');
  }

  return response.json();
}
